import React, { useEffect, useState } from 'react';
import LinkPhoneModal from './LinkPhoneModal';
import LoadingScreen from './LoadingScreen';
import { api } from '../services/api';
import { userHasPhoneCredential } from '../utils/authPhone';

/**
 * Web dashboard gate: email/Google accounts must link a phone.
 * Skip for users who already signed in with phone OTP (mobile app users on web).
 * Also skip when business profile already has owner_no on this uid (mobile onboarding).
 */
export default function PhoneLinkGate({ user, refreshUser, children }) {
  const [checking, setChecking] = useState(true);
  const [needsLink, setNeedsLink] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!user) {
        setNeedsLink(false);
        setChecking(false);
        return;
      }

      if (userHasPhoneCredential(user)) {
        setNeedsLink(false);
        setChecking(false);
        return;
      }

      try {
        const res = await api.getBusiness(user.uid);
        const biz = res?.data;
        const ownerNo = (biz?.owner_no || biz?.phone || '').trim();
        if (ownerNo) {
          setNeedsLink(false);
          setChecking(false);
          return;
        }
      } catch (_) {
        // No business yet — still require phone link for email-only accounts.
      }

      if (!cancelled) {
        setNeedsLink(true);
        setChecking(false);
      }
    };

    setChecking(true);
    run();
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (checking) return <LoadingScreen />;
  if (user && needsLink) return <LinkPhoneModal onLinked={refreshUser} />;
  return children;
}
